import { service } from '../../../../helpers/http' 

export const ActionGetModules = ({ dispatch }, payload) => { 
    return service({
        module: 'planModule',
        action: 'getModules',
        payload: payload
    })
}

export const ActionPostModules = ({ dispatch }, payload) => {

    return service({
        module: 'planModule',
        action: 'postModules',
        payload: payload
    })
    
}

export const ActionPutModules = ({ dispatch }, payload) => {

    return service({
        module: 'planModule',
        action: 'putModules',
        payload: payload
    })
    
}

export const ActionDeleteModules = ({ dispatch }, payload) => {

    return service({
        module: 'planModule',
        action: 'deleteModules',
        payload: payload
    })
    
}
